import { ref, toRef, onMounted } from 'vue'
import { api } from '@/helpers/api'
import useGetStartedSteps from './useGetStartedSteps'

const URLS = {
    xhr: {
        fetch: {
            getStarted: '/api/profile/get-started'
        }
    }
}
const load = ref(false)
const getStartedInfo = ref({})

export default function (props, fetchInfo = true) {
    const role = toRef(props, 'role')
    const { STEP_STATUS, getStartedSteps, stepStatus } = useGetStartedSteps(getStartedInfo, role)

    ;(async () => {
        if (fetchInfo) {
            getStartedInfo.value = await fetchGetStartedInfo()
        }
    })()

    onMounted(() => {
        localStorage.clear()
    })

    async function fetchGetStartedInfo() {
        try {
            load.value = true
            const data = await api({
                method: 'get',
                url: `${URLS.xhr.fetch.getStarted}/${role.value}`
            })
            return data.data
        } finally {
            load.value = true
        }
    }

    return {
        STEP_STATUS,
        load,
        role,
        getStartedSteps,
        stepStatus,
        getStartedInfo,

        fetchGetStartedInfo
    }
}
